// These hardcoded paths bypass the generated API contract. Use Orval clients for
// API requests; these exceptions are needed for browser redirects and file URLs.
export const HARDCODED_BACKEND_PATHS = {
    SSO: "/api/single-sign-on",
    BLOBS: "/api/blobs",
} as const;
